<template>
    <h5 class="card-title">
        <slot />
    </h5>
</template>
